<template>
    <v-toolbar flat>
        <span class="toolbar-title">Tickets</span>
        <v-spacer />        
        <TicketMapNavButtons />
    </v-toolbar>
</template>
<script>
import TicketMapNavButtons from './TicketMapNavButtons';
export default {
    components: {       
        TicketMapNavButtons    
    },
    props: {
        selectedTickets: {
            type: Array,
            default: () => [],
        },
        differencesDisabled: {
            type: Boolean,
        },
        reopenDisabled: {
            type: Boolean
        },
        respondDisabled: {
            type: Boolean
        },
        assignDisabled: {
            type: Boolean
        },    
    },
    data: () => ({
        tableMapToggle: 'table',
    }),
    methods: {
        emitCompare() {
            this.$emit('open-compare-dialog');
        },
        emitRespond() {
            this.$emit('open-respond-dialog');
        },
        emitAssign() {
            this.$emit('open-assign-dialog');
        }
    }
};
</script>